let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7v6wU"), load("b544F"), load("a8heY"), load("bRVT8")]).then(() => parcelRequire('iDFnq'));